import permissions from './permission-list'

export default [
  {
    path: '/vouchers',
    name: 'vouchers',
    component: () => import('@/views/vouchers/index.vue'),
    meta: {
      pageTitle: 'Daftar Voucher',
      resource: permissions.voucher,
      action: 'read',
      navActiveLink: 'vouchers',
      breadcrumb: [
        {
          text: 'Voucher',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vouchers/create',
    name: 'vouchers-create',
    component: () => import('@/views/vouchers/create.vue'),
    meta: {
      pageTitle: 'Buat Voucher',
      resource: permissions.voucher,
      action: 'manage',
      navActiveLink: 'vouchers',
      breadcrumb: [
        {
          text: 'Voucher',
          active: false,
          to: { path: '/vouchers' },
        },
        {
          text: 'Buat',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vouchers/:id/edit',
    name: 'vouchers-edit',
    component: () => import('@/views/vouchers/edit.vue'),
    meta: {
      pageTitle: 'Edit Voucher',
      resource: permissions.voucher,
      action: 'manage',
      navActiveLink: 'vouchers',
      breadcrumb: [
        {
          text: 'Voucher',
          active: false,
          to: { path: '/vouchers' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vouchers/:id/poster',
    name: 'vouchers-poster',
    component: () => import('@/views/vouchers/poster/index.vue'),
    meta: {
      pageTitle: 'Poster Voucher',
      resource: permissions.voucher,
      action: 'manage',
      navActiveLink: 'vouchers',
      breadcrumb: [
        {
          text: 'Voucher',
          active: false,
          to: { path: '/vouchers' },
        },
        {
          text: 'Poster',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vouchers/:id/poster/print',
    name: 'vouchers-print',
    component: () => import('@/views/vouchers/poster/print.vue'),
    meta: {
      layout: 'full',
      resource: permissions.voucher,
      action: 'manage',
      navActiveLink: 'vouchers',
    },
  },
]
